export default __webpack_public_path__ + "static/media/aghst.266f1477.svg";